"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Playground = void 0;
var env_1 = require("./env");
var mesh_1 = require("../mesh");
var dom_cube_1 = require("../mesh/dom-cube");
var util_1 = require("../util");
var Playground = /** @class */ (function (_super) {
    __extends(Playground, _super);
    function Playground(base) {
        var _this = _super.call(this) || this;
        _this.base = base;
        _this.ready = false;
        _this.initTimeoutDuration = 1000;
        _this.init();
        return _this;
    }
    Playground.prototype.init = function () {
        var _this = this;
        this.base.getResources().then(function () {
            _this.env = new env_1.Env(_this.base);
            _this.trigger('env-ready');
            clearTimeout(_this.initTimeout);
            _this.initTimeout = setTimeout(function () {
                _this.cube = new mesh_1.Cube(_this.base);
                _this.domCube = new dom_cube_1.DomCube(_this.base);
                _this.ready = true;
                _this.trigger('ready');
            }, _this.initTimeoutDuration);
        });
    };
    Playground.prototype.showChat = function () {
        this.cube.showChat();
        this.domCube.showChat();
        if (this.base.getLoginStatus()) {
            this.domCube.chat.showScreen('guestList');
        }
        else {
            this.domCube.chat.showScreen('loginGuide');
        }
    };
    Playground.prototype.showMusic = function () {
        this.cube.showMusic();
        this.domCube.showMusic();
    };
    Playground.prototype.update = function (delta) {
        if (this.ready) {
            this.env.update(delta);
            this.cube.update(delta);
            this.domCube.update(delta);
        }
    };
    return Playground;
}(util_1.EventEmitter));
exports.Playground = Playground;
